import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MessageService } from 'primeng/api'

import { ApiLeaseService } from '@modules/private/lease/data/services/api/api-lease.service'

/**
 * Diálogo para asignar (de forma unitaria) una cartera (Wallet) a un arrendamiento.
 * Lo usa el detalle del lease. El host lo abre vía `@ViewChild(...).open()`.
 */
@Component({
  selector: 'app-assign-wallet-dialog',
  templateUrl: './assign-wallet-dialog.component.html',
})
export class AssignWalletDialogComponent {
  @Input() leaseId?: string
  /** Se emite tras una asignación exitosa para que el host refresque. */
  @Output() assigned = new EventEmitter<void>()

  visible = false
  saving = false
  loadingOptions = false
  options: { _id: string; name: string }[] = []
  selectedWalletId: string | null = null

  constructor(
    private readonly apiLease: ApiLeaseService,
    private readonly messageService: MessageService
  ) {}

  open(): void {
    this.selectedWalletId = null
    this.visible = true
    if (!this.options.length) this.loadOptions()
  }

  private loadOptions(): void {
    this.loadingOptions = true
    this.apiLease.getWalletOptions().subscribe((opts) => {
      this.options = opts || []
      this.loadingOptions = false
    })
  }

  confirm(): void {
    if (!this.selectedWalletId || this.saving || !this.leaseId) return
    this.saving = true
    this.apiLease.assignWallet(this.leaseId, this.selectedWalletId).subscribe((r) => {
      this.saving = false
      if (r.error) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: r.msg, life: 5000 })
        return
      }
      this.messageService.add({ severity: 'success', summary: 'Cartera asignada', detail: 'Cartera asignada al arrendamiento.', life: 4000 })
      this.visible = false
      this.assigned.emit()
    })
  }
}
